import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, X } from 'lucide-react';
import type { Ad } from '../../types';
import { ADS } from '../../constants/testIds';

export function TopbarAd({ ad }: { ad: Ad }) {
  const key = `ad_topbar_${ad.id}_${ad.updated_at || ad.created_at || 'v'}`;
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(key) === '1');
  if (dismissed) return null;

  const close = () => { sessionStorage.setItem(key, '1'); setDismissed(true); };
  const isInternal = ad.button_link?.startsWith('/');

  return (
    <div
      data-testid={ADS.topbar}
      className="relative z-40 bg-gradient-to-r from-cyan-500 to-blue-600 text-[#050914] pl-4 pr-10 py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm"
    >
      <Megaphone className="w-4 h-4 shrink-0" strokeWidth={2} />
      <p className="font-medium truncate">
        {ad.title}
        {ad.content && <span className="font-normal opacity-80"> — {ad.content}</span>}
      </p>
      {ad.button_label && ad.button_link && (
        isInternal ? (
          <Link data-testid={ADS.topbarCta} to={ad.button_link} className="shrink-0 underline underline-offset-2 font-semibold hover:opacity-80">
            {ad.button_label}
          </Link>
        ) : (
          <a data-testid={ADS.topbarCta} href={ad.button_link} target="_blank" rel="noreferrer" className="shrink-0 underline underline-offset-2 font-semibold hover:opacity-80">
            {ad.button_label}
          </a>
        )
      )}
      <button data-testid={ADS.topbarClose} onClick={close} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-black/10">
        <X className="w-4 h-4" strokeWidth={2} />
      </button>
    </div>
  );
}
